import { STATE_TOKEN_KEY_NAME } from '@okta/okta-auth-js';
import React, { useMemo, useRef, useState } from 'react';
import { FormControlLabel, IconButton, Popover, Stack, Switch, Typography } from '@mui/material';

import { useSeismicStore } from '../stores/useSeismicStore';
import { ScaleBarUnit, SeismicScaleBar } from './SeismicScaleBar';
import { AmplitudeDomain } from '../models/enums/AmplitudeDomain';
import { SampleIntervalUnit } from '../models/enums/SampleIntervalUnity';
import { GeopostPopover } from 'components/GeopostPopover';
import { getUrlParams } from 'features/seismic-3d/utils/Seismic3DUrlUtils';

type ScaleBars2DProps = {
    showVerticalBar: boolean,
    showHorizontalBar: boolean,
};

export const ScaleBars2D = ( { showHorizontalBar, showVerticalBar } : ScaleBars2DProps ) => {
    const surveyMetadata = useSeismicStore(state => state.surveyMetadata);
    const sampleInterval = useMemo(() => surveyMetadata?.Header.SampleIntervalUnit === SampleIntervalUnit.Microsecond ? surveyMetadata.Header.SampleInterval / 1000 : surveyMetadata?.Header.SampleInterval, [surveyMetadata]);
    const tenantToken = getUrlParams().tenantToken;

    return (
        <React.Fragment>
            {
                !!surveyMetadata
                &&
                <React.Fragment>
                    {
                        !!sampleInterval
                        &&
                        showVerticalBar
                        &&
                        <SeismicScaleBar unit={surveyMetadata.Domain === AmplitudeDomain.Time ? ScaleBarUnit.Miliseconds : (tenantToken === '0ac67c23-988b-4fec-b078-26b15c8b8b4b' ? ScaleBarUnit.Feet : ScaleBarUnit.Meter)} unitDistance={sampleInterval} vertical/>
                    }
                    {
                        showHorizontalBar
                        &&
                        <SeismicScaleBar unit={(tenantToken === '0ac67c23-988b-4fec-b078-26b15c8b8b4b' ? ScaleBarUnit.Kilofoot : ScaleBarUnit.Kilometer)} unitDistance={surveyMetadata?.Header.AverageTraceDistance}/>
                    }
                </React.Fragment>
            }
        </React.Fragment>
    );
};